import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/** What each Section 604 affidavit detail means to an owner. */
export const fieldMeanings = declareFieldMeanings({
  sources: ['section604'],
  declarations: [
    identity(
      'address',
      'block',
      'lot',
      'street_name',
      'street_number_low',
      'street_number_high',
      'street_suffix',
      'unit',
      'item',
    ),
    administrative(
      'link',
      'latitude',
      'longitude',
      'data_as_of',
      'data_loaded_at',
      ':id',
      ':created_at',
      ':updated_at',
    ),
    means('date', 'the affidavit inspection date', ['inspectionDate', 'inspection_date']),
    means('description', "the inspector's comment", ['comments'], {
      matters: 'added or changed a note',
      means:
        "This is the inspector's comment on the affidavit. A change means the comment was added or changed.",
    }),
  ],
});
